gsap.registerPlugin(ScrollTrigger);

let parentElement = document.querySelector('.expanding-banner');
let parentHeight = parentElement?.offsetHeight;
let childElement = document.querySelector('.expanding-banner .block');
let viewHeight = window.visualViewport?.height;

const element = parentElement.querySelector('.block');
const mediaContainer = parentElement.querySelector('.media-container');
const media = parentElement.querySelector('.media-container img, .media-container video');
const contentWrapper = parentElement.querySelector('.content-wrapper');
const graphicsWrapper = parentElement.querySelector('.graphics-wrapper');
const overlay = parentElement.querySelector('.media-container .overlay');

mm.add('(min-width: 1025px)', () => {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: element,
            start: 'top top',
            end: '+=100%',
            pin: true,
            pinSpacing: true,
            pinType: 'transform',
            scrub: true,
            invalidateOnRefresh: true,
        },
    });

    // Clip mask reveal animation
    tl.to(mediaContainer, {
        maskSize: '110%',
        duration: 2,
        ease: 'power3.inOut',
    });
    tl.to(
        media,
        {
            scale: 1,
            duration: 2,
            ease: 'power3.out',
        },
        '<'
    );
    // fade out graphics right beore content reveal
    tl.to(
        graphicsWrapper,
        {
            opacity: 0,
            duration: 1,
            ease: 'power2.inOut',
        },
        '-=1.2'
    );

    tl.to(
        mediaContainer.querySelector('.overlay'),
        {
            opacity: 0.5,
            duration: 1,
            ease: 'power2.inOut',
        },
        '-=1.2'
    );

    // Fade in text after clip reveal
    tl.to(
        contentWrapper,
        {
            opacity: 1,
            duration: 0.8,
            ease: 'power2.inOut',
        },
        '-=1'
    );
});

mm.add('(max-width: 1024px)', () => {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: mediaContainer,
            start: 'top 70%',
            end: 'bottom 20%',
            pin: false,
            invalidateOnRefresh: true,
            toggleActions: 'play none none none',
            scrub: true,
        },
    });
    tl.from(
        mediaContainer,
        {
            maskSize: '30%',
            duration: 1,
            ease: 'power3.out',
        },
        '<'
    );
    tl.to(
        media,
        {
            scale: 1,
            duration: 1,
            ease: 'power3.out',
        },
        '<'
    );
    tl.to(
        contentWrapper,
        {
            opacity: 1,
            duration: 0.8,
            ease: 'power2.inOut',
        },
        '-=0.8'
    );
});
